import { Alert, Box, useTheme } from "@mui/material";
import * as React from "react";

import { SearchResults } from "@/Search/SearchResults";
import { useDeviceFiles } from "@/shared/domain/devices/hooks/useDeviceFiles";

import { useDeviceContext } from "../Device/useDeviceContext";

/**
 * Files tab on the device detail view. Lists every file across the
 * organization whose `device_id` matches the device the user is viewing,
 * rendered through the shared `<SearchResults />` table.
 */
export function DeviceFiles() {
  const theme = useTheme();
  const { deviceId, org } = useDeviceContext();
  const [lastError, setLastError] = React.useState<Error | null>(null);

  const { data: queryId, error } = useDeviceFiles(deviceId, org?.org_id);

  if (error) {
    return (
      <Box mt={theme.spacing(1)} mb={theme.spacing(2)}>
        <Alert severity="error">
          Failed to load files for device {deviceId}: {error.message}
        </Alert>
      </Box>
    );
  }

  return (
    <Box mt={theme.spacing(-1)} mb={theme.spacing(2)}>
      <SearchResults
        queryId={queryId}
        lastError={lastError}
        onError={setLastError}
      />
    </Box>
  );
}
